/* Indie House PDP editorial: move existing product information accordion under trust;
   one-open-at-a-time details; Buy Now into native Shopify checkout without cart drawer. */
(() => {
  if (window.__ihPdpEditorialReady) return;
  window.__ihPdpEditorialReady = true;

  // Native Shopify section blocks render in exact Theme Editor order.
  // Older browsers: enforce single-open accordion when details[name] grouping is unavailable.
  document.addEventListener('toggle', e=>{
    const details=e.target;
    if(!(details instanceof HTMLDetailsElement) || !details.open || !details.matches('.product-info--primary .indie-utility-accordion'))return;
    const section=details.closest('.shopify-section--main-product');
    section?.querySelectorAll('.product-info--primary .indie-utility-accordion[open]').forEach(item=>{
      if(item!==details)item.open=false;
    });
  },true);

  let busy = false;
  document.addEventListener('click',async e=>{
    const hit=e.target instanceof Element?e.target:e.target?.parentElement;
    const button=hit?.closest('[data-ih-pdp-buy-now]');
    if(!button || button.disabled || busy) return;
    e.preventDefault();e.stopPropagation();
    const gate=button.closest('buy-buttons');
    if(gate?.dataset.ihP1Gated === 'true' && gate.dataset.ihP1Active!=='true') {
      gate.querySelector('[data-ih-p1-action-prompt]')?.click();
      return;
    }
    const formId=button.getAttribute('data-product-form');
    const form=formId?document.getElementById(formId):null;
    const error=gate?.querySelector('[data-ih-pdp-buy-now-error]');
    const showError=message=>{if(error){error.textContent=message;error.hidden=false;}else alert(message);};
    if(error){error.hidden=true;error.textContent='';}
    if(!form){showError('Product form unavailable. Please refresh and retry.');return;}
    const variantInput=form.querySelector('input[name="id"]');
    const variantId=variantInput?.value?.trim();
    if(!variantId || !/^\d+$/.test(variantId)){showError('Please select an available size first.');return;}
    const data=new FormData(form);
    data.set('id',variantId); // Native variant picker can disable its hidden ID field.
    if(!data.has('quantity')) data.set('quantity','1');
    // Shopify cart/add.js then /checkout preserves any existing cart items
    // and goes directly to checkout without showing the bag page/drawer.
    busy=true;button.disabled=true;button.setAttribute('aria-busy','true');
    const saved=button.innerHTML;
    button.textContent='REDIRECTING TO CHECKOUT…';
    try{
      const root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart/add.js',{
        method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:data
      });
      if(!response.ok){
        const body=await response.json().catch(()=>null);
        throw Error(body?.description||body?.message||'Could not add this item. Please try another size.');
      }
      window.location.assign(root+'checkout');
    }catch(err){
      showError(err?.message||'Checkout could not be started. Please try again.');
      busy=false;button.disabled=false;button.removeAttribute('aria-busy');button.innerHTML=saved;
    }
  },true);

})();